// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'core-js/es6/promise'
import 'core-js/es6/string'
import 'core-js/es7/array'
// import cssVars from 'css-vars-ponyfill'
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import App from './App'
import router from './router'
import store from './store'
import { dateFilter } from './utils/filters'

// 3rd party libs
import VModal from 'vue-js-modal'
import * as VueGoogleMaps from 'vue2-google-maps'
import Toasted from 'vue-toasted'

// todo
// cssVars()

Vue.use(BootstrapVue)
Vue.use(VModal, { dynamic: true, injectModalsContainer: true, height: 'auto' })
Vue.use(Toasted, {position: 'top-right', duration: 2000, iconPack : 'fontawesome', singleton: true})
// Global server error
Vue.toasted.register('server_error', 'Oops..Server error occurred.', {
  type : 'error',
  icon : 'fa-frown-o'
})
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyCwXjU4WURykqYSplepHTt7koijVAQfgf4',
    libraries: 'places',
  }
})
Vue.filter('date', dateFilter)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  store,
  components: {
    App
  }
})
